import { render, staticRenderFns } from "./channelType.vue?vue&type=template&id=0b8387bb"
import script from "./channelType.vue?vue&type=script&lang=js"
export * from "./channelType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports